// src/lib/stores/supabaseStore.ts
import { writable } from 'svelte/store';
import type { SupabaseClient } from '@supabase/supabase-js';

// Create a writable store for the Supabase client
export const supabaseStore = writable<SupabaseClient | null>(null);

// Helper function to set the Supabase client
export const setSupabaseClient = (client: SupabaseClient) => {
	supabaseStore.set(client);
};
